import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromSelectedStudents from "./selected-students.reducer";
import * as fromAssignSettings from "./assign-settings.reducer";

// this is the type for our assignables.module
// this creates the structure for our state tree
export interface AssignState {
    selectedStudents: fromSelectedStudents.AssignListState;
    assignSettings: fromAssignSettings.AssignSettingsState;
}

// register the reducers
// a slice of state is managed by a reducer function
// ** Remember a reducer is a pure function
// this can be type check with ActionReducerMap as type AssignState
export const reducers: ActionReducerMap<AssignState> = {
    selectedStudents: fromSelectedStudents.reducer,
    assignSettings: fromAssignSettings.reducer
};

// This const creates the base level of our state object
// A reference to our Assignables State
// and will hold a selector for the entire lazy-loaded module
export const getAssignModuleState = createFeatureSelector<AssignState>(
    "assignModule"
);
